<template>
  <b-skeleton-wrapper :loading="loading">
    <template #loading>
      <div class="bg-gray-50 rounded-lg p-4 flex flex-col items-start justify-center shadow-sm">
        <b-skeleton animation="wave" width="50%" height="14px" class="mb-1"></b-skeleton>
        <div class="flex items-center gap-2 mt-1">
          <b-skeleton animation="wave" width="60px" height="36px"></b-skeleton>
          <b-skeleton animation="wave" width="100px" height="16px"></b-skeleton>
          <b-skeleton animation="wave" width="24px" height="24px"></b-skeleton>
        </div>
      </div>
    </template>
    <div class="bg-gray-50 rounded-lg p-4 flex flex-col items-start justify-center shadow-sm">
      <p class="text-gray-600 text-sm font-medium mb-1">Racha Actual</p>
      <div class="flex items-center">
        <p class="text-4xl font-bold text-gray-800">{{ currentStreak }}</p>
        <span class="text-base text-gray-600 ml-2">Días de Racha</span>
        <span class="ml-2 text-xl">🔥</span>
      </div>
    </div>
  </b-skeleton-wrapper>
</template>

<script>
import { getCurrentStreakKpi } from '@/services/stats.service';

export default {
  name: 'CurrentStreak',

  data() {
    return {
      currentStreak: 0,
      loading: true,
    };
  },

  props: {
    isPremium: {
      type: Boolean,
      default: true
    },
    forStudentId: {
      type: [Number, String],
      default: null
    }
  },

  watch: {
    isPremium(newValue) {
      if (newValue) {
        this.loading = true;
        this.loadCurrentStreak();
      }
    },
    forStudentId() {
      if (this.isPremium) {
        this.loading = true;
        this.loadCurrentStreak();
      }
    }
  },

  async created() {
    // Si no es premium, mantener loading indefinidamente y no cargar datos
    if (!this.isPremium) {
      this.loading = true;
      return;
    }

    await this.loadCurrentStreak();
  },

  mounted() {
    // Si no es premium, mantener skeleton indefinidamente
    if (!this.isPremium) {
      this.loading = true;
    }
  },

  methods: {
    async loadCurrentStreak() {
      if (!this.isPremium) {
        return;
      }

      const data = await getCurrentStreakKpi(this.forStudentId);
      this.currentStreak = data?.streak || 0;
      this.loading = false; // Ocultar skeleton inmediatamente después de cargar
    }
  }
};
</script>
